import React, { ChangeEvent } from "react";
import ATMInputAdormant from "../formFields/ATMInputAdormant/ATMInputAdormant";
import { BiSearch, BiFilter } from "react-icons/bi";
import ATMLoadingButton from "../ATMLoadingButton/ATMLoadingButton";
import { usePermission } from "src/hooks/usePermission";

type Props = {
  pageTitle: string;
  searchValue?: string;
  moduleName:string; 
  onSearchChange?: (
    newValue: string,
    event: ChangeEvent<HTMLInputElement>
  ) => void;
  buttonProps?: {
    btnName?: string;
    onClick: () => void;
    className?: string;
  };
  extraButtonProps?: {
    btnName?: string;
    onClick: () => void;
    className?: string;
  }[];
  extraButton?: boolean;
  hideAddButton?: boolean;
  hideSearchBox?: boolean;
  isFilter?: boolean;
  onFilterClick?: () => void;
};

const ATMPageHeader = ({
  moduleName,
  pageTitle,
  searchValue = "",
  onSearchChange,
  extraButton = false,
  hideAddButton = false,
  extraButtonProps = [{ btnName: "", onClick: () => {}, className: "" }],
  buttonProps = { btnName: "Add New", onClick: () => {}, className: "" },
  hideSearchBox = false,
  isFilter = false,
  onFilterClick = () => {},
}: Props) => {
  const canAddUser = usePermission(moduleName?.toLocaleUpperCase(), "ADD");
  return (
    <div className="flex gap-3 justify-between items-center flex-wrap">
      <div className="text-xl font-medium text-slate-700">{pageTitle}</div>
      <div className="flex gap-2 items-center flex-wrap justify-end">
        {isFilter && (
          <button
            onClick={() => onFilterClick()}
            className="bg-white shadow px-2 flex items-center rounded border"
          >
            <BiFilter className="text-2xl text-slate-600" />
          </button>
        )}

        {hideSearchBox ? null : (
          <div className="w-[300px]">
            <ATMInputAdormant
              name=""
              value={searchValue}
              onChange={(e) => onSearchChange?.(e.target.value, e)}
              adormant={<BiSearch />}
              adormantProps={{
                position: "start",
                extraClasses: "bg-white border-0",
              }}
              inputProps={{ className: "bg-white" }}
              placeholder="Search..."
            />
          </div>
        )}
        {!extraButton ? null : (
          <div className="flex gap-2">
            {extraButtonProps?.map((btn, index) => (
              <ATMLoadingButton
                key={index}
                onClick={btn.onClick}
                className={btn.className}
              >
                {btn.btnName}
              </ATMLoadingButton>
            ))}
          </div>
        )}

        {hideAddButton ? null : (
          <div>
            {canAddUser && (
              <ATMLoadingButton
                onClick={buttonProps?.onClick}
                className={buttonProps?.className}
              >
                {buttonProps?.btnName}
              </ATMLoadingButton>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ATMPageHeader;
